import { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { subscriptionsService } from "./service";
import type { SubscriptionTier } from "./types";

/**
 * Fetches the current user's subscription tier once on mount (when authenticated).
 * Returns `null` while loading or for anonymous visitors.
 */
export function useMyTier(): SubscriptionTier | null {
  const { isAuthenticated, isAuthReady } = useAuth();
  const [tier, setTier] = useState<SubscriptionTier | null>(null);

  useEffect(() => {
    if (!isAuthReady || !isAuthenticated) {
      setTier(null);
      return;
    }
    let cancelled = false;
    subscriptionsService
      .getMyTier()
      .then((res) => {
        if (!cancelled) setTier(res.tier as SubscriptionTier);
      })
      .catch(() => {
        /* tier badge is non-critical — stay silent on failure */
      });
    return () => {
      cancelled = true;
    };
  }, [isAuthReady, isAuthenticated]);

  return tier;
}
